// extracted by mini-css-extract-plugin
export var logo = "LogosModule-module--logo--36b69";
export var logoContainer = "LogosModule-module--logoContainer--838a4";
export var logosContainer = "LogosModule-module--logosContainer--ba54e";
export var noAnimation = "LogosModule-module--noAnimation--a3d4c";
export var slider = "LogosModule-module--slider--d1ca5";
export var sliderWrapper = "LogosModule-module--sliderWrapper--8ac0a";